import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { NotificationGroup as NotificationGroupType } from "../../types";

import NotificationGroup from "./notification-group";

const FeedContainer = css({
    padding: token("space.200")
});

interface GroupedNotifications {
    today: NotificationGroupType[];
    yesterday: NotificationGroupType[];
    thisWeek: NotificationGroupType[];
    thisMonth: NotificationGroupType[];
    older: NotificationGroupType[];
}

interface NotificationFeedProps {
    groupedNotifications: GroupedNotifications;
    onExpand: (groupId: string, continuationToken?: string) => void;
    notificationLogUrl: string;
    loadingGroupId?: string | null;
}

const NotificationFeed = ({
    groupedNotifications,
    onExpand,
    notificationLogUrl,
    loadingGroupId
}: NotificationFeedProps) => {
    const { today, yesterday, thisWeek, thisMonth, older } =
        groupedNotifications;

    return (
        <div css={FeedContainer}>
            {today.length > 0 && (
                <NotificationGroup
                    title="Today"
                    notificationGroups={today}
                    onExpand={onExpand}
                    notificationLogUrl={notificationLogUrl}
                    loadingGroupId={loadingGroupId}
                />
            )}
            {yesterday.length > 0 && (
                <NotificationGroup
                    title="Yesterday"
                    notificationGroups={yesterday}
                    onExpand={onExpand}
                    notificationLogUrl={notificationLogUrl}
                    loadingGroupId={loadingGroupId}
                />
            )}
            {thisWeek.length > 0 && (
                <NotificationGroup
                    title="This Week"
                    notificationGroups={thisWeek}
                    onExpand={onExpand}
                    notificationLogUrl={notificationLogUrl}
                    loadingGroupId={loadingGroupId}
                />
            )}
            {thisMonth.length > 0 && (
                <NotificationGroup
                    title="This Month"
                    notificationGroups={thisMonth}
                    onExpand={onExpand}
                    notificationLogUrl={notificationLogUrl}
                    loadingGroupId={loadingGroupId}
                />
            )}
            {older.length > 0 && (
                <NotificationGroup
                    title="Older"
                    notificationGroups={older}
                    onExpand={onExpand}
                    notificationLogUrl={notificationLogUrl}
                    loadingGroupId={loadingGroupId}
                />
            )}
        </div>
    );
};

export default NotificationFeed;
